<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n.js'
defineProps({ title: String, pending: Boolean, busy: Boolean, error: String, id: String })
const emit = defineEmits(['apply', 'clear', 'close'])
const { t } = useI18n()
function keydown(event) { if (event.key === 'Enter' && event.target.tagName !== 'BUTTON') event.preventDefault() }
</script>
<template>
  <form :id="id" class="journal-filter-panel" novalidate @submit.prevent="emit('apply')" @keydown="keydown" @keydown.esc.stop.prevent="emit('close')">
    <header><h2>{{ title }}</h2><button class="journal-filter-close" type="button" :aria-label="t('journalCloseFilters')" @click="emit('close')"><XMarkIcon aria-hidden="true" /></button></header>
    <slot />
    <p v-if="error" :id="`${id}-error`" class="notice error" role="alert">{{ t(error) }}</p>
    <footer><p class="muted">{{ t('journalApplyHint') }}</p><div><button class="button button-secondary" type="button" :disabled="busy" @click="emit('clear')">{{ t('journalClearAll') }}</button><button class="button" type="submit" :disabled="busy">{{ t('applyFilters') }}</button></div></footer>
  </form>
</template>
